import React from 'react';
import request, { METHODS } from '@/api'
import { useEffect, useState } from 'react'
import {
  SEditor,
  SDrawerOrModal,
} from 'shj-components'
import { Form, Input, Select, message, DatePicker, InputNumber } from 'antd';
import dayjs from 'dayjs';
import { authDict } from 'shj-utils';
import { updateCustomerInfo, getCustomerCareerEnum } from '@/services/customerServices';
import styles from './index.module.less'

export default function EditBasicInfoModal ({
  customerInfo= { customerInfo: {}, memberInfo: {}},
  editId = '',
  open = false,
  onClose = () => {},
  reload = () => {},
})  {
  const [ form ] = Form.useForm();
  const [dictionaryData, setDictionaryData] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchDictionaryData();
 
    if (customerInfo) {
      form.setFieldsValue({
        ...(customerInfo.customerInfo || {}),
        ...(customerInfo.memberInfo || {})
      })
    }
  }, []);

  const fetchDictionaryData = async () => {
    try {
      const resList: any = await Promise.allSettled([
        getCustomerCareerEnum(),
      ]);
      const map = {
        career: resList?.[0]?.value instanceof Array ? resList?.[0]?.value : [],
      }
      setDictionaryData(map);
    } catch (err) {
      console.log(err)
    }
  }

  const onSubmit = () => {
    form.validateFields().then(async (values: any) => {
      try {
        setLoading(true);
        const res: any = await updateCustomerInfo({ customerId: editId, ...values })
        setLoading(false);
        if (res.errorCode === 0 && res.status) {
          message.success('编辑客户信息成功');
          onClose();
          reload();
        } else {
          message.error('编辑客户信息失败');
        }
      } catch(err) {
        setLoading(false);
        console.log(err)
      }
    })
  }

  return (
    <div className={styles.bditBasicInfoModal}>
      <SDrawerOrModal
        mode="drawer"
        open={open}
        onCancel={() => onClose()}
        onOk={onSubmit}
        loading={loading}
        width="30%"
        title="编辑客户信息"
      >
        <Form
          form={form}
          labelCol={{
            span: 8,
          }}
          name="basicInfo"
          layout="vertical"
        >
          <Form.Item
            name="name"
            label="客户姓名"
            rules={[
              {
                required: true,
                message: '请填写客户姓名',
              },
            ]}
            style={{
              width: '100%'
            }}
          >
            <Input placeholder={'请填写客户姓名'} maxLength={20} />
          </Form.Item>
          <Form.Item
            name="phone"
            label="客户号码"
            rules={[
              {
                required: true,
                message: '请填写客户号码',
              },
            ]}
            style={{
              width: '100%'
            }}
          >
            <Input placeholder={'请填写客户号码'} disabled={!authDict?.['viewPhoneRights2']} />
          </Form.Item>
          <Form.Item
            name="gender"
            label="性别"
            style={{
              width: '100%'
            }}
          >
            <Select placeholder={'请填写客户姓名'} options={[{value: '男', label: '男'}, {value: '女', label: '女'}]} />
          </Form.Item>
          <Form.Item
            name="age"
            label="年龄"
            style={{
              width: '100%'
            }}
          >
            <InputNumber placeholder={'请填写年龄'} style={{ width: '100%' }} precision={0} />
          </Form.Item>
          <Form.Item
            name={'birthday'}
            label="生日"
            getValueProps={(value) => ({
              value: value && dayjs(Number(value)),
            })}
            normalize={(value) => value && `${dayjs(value).valueOf()}`}
          >
            <DatePicker style={{ width: '100%' }} />
          </Form.Item>
          <Form.Item
            name={'career'}
            label="职业"
            style={{
              width: '100%'
            }}
          >
            <Select placeholder={'请选择职业'} fieldNames={{label: 'description', value: 'key' }} options={dictionaryData['career']} />
          </Form.Item>
          <Form.Item
            name="email"
            label="邮箱"
            style={{
              width: '100%'
            }}
          >
            <Input placeholder={'请填写邮箱'}/>
          </Form.Item>
        </Form>
      </SDrawerOrModal>
    </div>
  )
}